%YAML 1.1
%TAG !u! tag:unity3d.com,2011:
--- !u!114 &11400000
MonoBehaviour:
  m_ObjectHideFlags: 0
  m_CorrespondingSourceObject: {fileID: 0}
  m_PrefabInstance: {fileID: 0}
  m_PrefabAsset: {fileID: 0}
  m_GameObject: {fileID: 0}
  m_Enabled: 1
  m_EditorHideFlags: 0
  m_Script: {fileID: 11500000, guid: f1565e2ac6d6cbe4bb0b302c1b554d10, type: 3}
  m_Name: ShieldWall
  m_EditorClassIdentifier: 
  impactPrefab: {fileID: 0}
  handGlowPrefab: {fileID: 0}
  handGlowScale: 0.2
  castAuraPrefab: {fileID: 7649805383090479649, guid: f35254fae1fea054bb028dad35611c32,
    type: 3}
  castAuraScale: 1
  castAuraYOffset: 0.18
  attachCastAuraToCaster: 1
  playOnCast: []
  castSound: {fileID: 0}
  castSoundVolume: 0.2
  soundBeforeChannel: {fileID: 0}
  beforeChannelSoundDelay: 0
  soundAfterChannel: {fileID: 0}
  afterChannelSoundDelay: 0
  animation: 0
  animationVariation: 20
  castDelay: 400
  animationSpeed: 2
  animationDuration: 1
  skipCooldownOnChannel: 0
  spellName: Empowered Shields
  description: Reduce all incoming damage by <b>90%</b> and reduce your damage done
    by <b>60%</b>. Lasts <b>10</b> seconds.
  icon: {fileID: 2800000, guid: ee221876e7c50f6449caf488c4dedb5c, type: 3}
  usableBy: 03000000
  cooldown: 90
  castTime: 0
  isCastInterruptible: 1
  channelTime: 0
  isOnGlobalCooldown: 1
  aoeRadius: 0
  isHidden: 0
  isInternal: 0
  isRegional: 0
  preventManualCasts: 0
  useKeyboardForFacing: 0
  spellType: {fileID: 11400000, guid: 80cddad32b4f07e4bbf640afdccb32f4, type: 2}
